import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LayoutInitService } from './core/services/layout-init.service';
import KTLayoutContent from '../../../assets/js/layout/base/content';
import { LayoutService } from './core/services/layout.service';
import { CoachMarkService } from 'src/app/account/core/services/coach-mark.service';
import { LoaderService } from './core/services/loader.service';
import { BRANDING_MEDIA } from '../core/constants/branding.constants';

@Component({
  selector: 'sc-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, AfterViewInit {
  // Public variables
  selfLayout = 'default';
  asideSelfDisplay: true;
  asideMenuDynamic: true;
  asideCSSClasses: string;
  asideHTMLAttributes: any = {};
  contentClasses = '';
  contentContainerClasses = '';
  headerCSSClasses: string;
  headerHTMLAttributes: any = {};
  subheaderDisplay = true;
  brandingMedia: any = BRANDING_MEDIA;

  isLoading: boolean;

  @ViewChild('scAside', { static: true }) scAside: ElementRef;
  @ViewChild('scHeaderMobile', { static: true }) scHeaderMobile: ElementRef;
  @ViewChild('scHeader', { static: true }) scHeader: ElementRef;

  constructor(
    private readonly initService: LayoutInitService,
    private readonly layout: LayoutService,
    private readonly coachMarkService: CoachMarkService,
    private readonly loaderService: LoaderService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {
    this.initService.init();
   }

  ngOnInit(): void {
    //aside layout config settings
    this.asideSelfDisplay = this.layout.getProp('aside.self.display');
    this.asideMenuDynamic = this.layout.getProp('aside.menu.dynamic');
    this.asideHTMLAttributes = this.layout.getHTMLAttributes('aside');
    this.asideCSSClasses = this.layout.getStringCSSClasses('aside');
    //content layout config settings
    this.contentClasses = this.layout.getStringCSSClasses('content');
    this.contentContainerClasses = this.layout.getStringCSSClasses(
      'content_container'
    );
    //header layout config settings
    this.headerCSSClasses = this.layout.getStringCSSClasses('header');
    this.headerHTMLAttributes = this.layout.getHTMLAttributes('header');
    //subheader layout config settings
    this.subheaderDisplay = this.layout.getProp('subheader.display');

    this.getCoachMark();
  }

  ngAfterViewInit(): void {
    this.loaderService.isLoading$.subscribe((response) => {
      this.isLoading = response;
      this.changeDetectorRef.detectChanges();
    });

    if (this.scAside) {
      for (const key in this.asideHTMLAttributes) {
        if (this.asideHTMLAttributes.hasOwnProperty(key)) {
          this.scAside.nativeElement.attributes[key] = this.asideHTMLAttributes[
            key
          ];
        }
      }
    }
    if (this.scHeader) {
      for (const key in this.headerHTMLAttributes) {
        if (this.headerHTMLAttributes.hasOwnProperty(key)) {
          this.scHeader.nativeElement.attributes[
            key
          ] = this.headerHTMLAttributes[key];
        }
      }
    }
    // Init Content
    KTLayoutContent.init('sc_content');
  }

  toggleAside() {
    document.body.classList.toggle('aside-minimize');
  }

  getCoachMark() {
    this.coachMarkService.getAllCoachMarks().subscribe();
  }

}
